import { setPXConverter } from "emrn-design/rpx";
import { getScreenWidth } from "emrn-design/getScreenWidth";

// web版像素转换器polyfill
(function () {
  const queryList = [1024, 1280, 1366, 1440, 1680, 1920].reverse();
  setPXConverter(function (px: number) {
    const screenWidth = getScreenWidth();
    const ratio = (queryList.find((w) => screenWidth > w) || screenWidth) / 375;
    return ratio <= 1 ? px : px * (1 + ratio * 0.1);
  });
})();
